import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'
import { Avatar, CaretRightIcon, ListItem } from '@okcredit/web-lib'
import { generateInitials } from 'utils/common/common.helpers'
import { IBusinessNameProps, IBusinessItemProps, ISubtitleProps } from './BusinessListItem.types'

import BusinessListItemStyles from './BusinessListItem.styles'

const styles = createUseStyles(BusinessListItemStyles)

const BusinessName: React.FC<IBusinessNameProps> = ({ name }) => {
  const classes = styles()
  return <span className={classes.businessName}>{name}</span>
}

const Subtitle: React.FC<ISubtitleProps> = ({ isAdmin }) => {
  const classes = styles()
  return (
    <span className={classes.subtitle}>
      {isAdmin ? 'OkCredit Account' : 'Added as Business Manager'}
    </span>
  )
}

const BusinessListItem: React.FC<IBusinessItemProps> = ({ id, name, avatar, isAdmin, onClick }) => {
  const classes = styles()
  const [hasError, setHasError] = useState(false)
  return (
    <ListItem
      className={classes.listItem}
      classList={{ container: classes.container }}
      onClick={onClick}
      tabIndex={0}
      id={id}
      key={id}
      icon={
        <Avatar
          alt={generateInitials(name)}
          size={44}
          src={hasError ? '' : avatar}
          onError={() => setHasError(true)}
        />
      }
      primary={<BusinessName name={name} />}
      secondary={<Subtitle isAdmin={isAdmin} />}
      endAdornment={<CaretRightIcon size={20} />}
    />
  )
}

export default BusinessListItem
